import { createFiltersSlice, type FiltersState } from "features/Application/slices/createFiltersSlice";
import { type CampaignFiltersEnum } from "../../types/models";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes, SortingDirection } from "enums";
import { DEFAULT_SORTING_COLUMN } from "../../types/constants";

export const initialState: FiltersState<CampaignFiltersEnum> = {
  filterOptions: {},
  appliedFilter: {},
  isLoading: false,
  pagination: 1,
  sortingColumnName: DEFAULT_SORTING_COLUMN,
  sortingDirection: SortingDirection.Descending,
  shouldSort: true,
};

const campaignFiltersSlice = createFiltersSlice({
  namePayload: {
    namespace: ReducerNamespaceTypes.Library,
    entity: ReducerEntityPrefixTypes.ThreatDefenceCampaigns,
    name: "overviewFilters",
  },
  initialState,
  reducers: {},
});

export const {
  setAppliedFilter,
  resetAppliedFilter,
  setIsLoading,
  setError,
  setFilterOptions,
  resetSearch,
  setSearch,
  setPagination,
  resetPagination,
  setSortingColumnName,
  resetSortingColumnName,
  setSortingDirection,
  resetSortingDirection,
  setShouldSort,
  resetShouldSort,
} = campaignFiltersSlice.actions;

export default campaignFiltersSlice.reducer;
